/* eslint-disable arrow-parens */
/* eslint-disable no-unused-vars */
// == Import : npm
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';

// Import boostrap
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import { globalConfig, globalConfigUrl } from './configuration/config';

// Componants
import store from './store';
import App from './components/App';

const bootstrap = require('bootstrap');
// == Render
// Root React element (the one that contains the entire app)
// => creates a nested object structure (virtual DOM)
const rootReactElement = (

  <Provider store={store}>
    <HashRouter>
      <App {...bootstrap} />
    </HashRouter>
  </Provider>
);
// 2. The DOM target (where the structure should come to life in the DOM)
const container = document.getElementById('root');
const root = createRoot(container);
// 3. Triggering React rendering (virtual) => DOM (web page)
axios.get(globalConfigUrl)
  .then((response) => {
    globalConfig.set(response.data);
    return <App />;
  })
  .catch((e) => <p style={{ color: 'red', textAlign: 'center' }}>Error while fetching global config</p>)
  .then((reactElement) => {
    root.render(rootReactElement);
  });

// root.render(rootReactElement);
